import React from 'react';

interface CategoriesMissionTabProps {
  t: (key: string) => string;
  loading: boolean;
  categoriesMission: { id: number; nom: string; created_at?: string }[];
  newCategoryName: string;
  setNewCategoryName: React.Dispatch<React.SetStateAction<string>>;
  editingMissionCategoryId: number | null;
  creatingCategory: boolean;
  handleSaveMissionCategory: () => void;
  handleCancelEditMissionCategory: () => void;
  handleEditMissionCategory: (c: { id: number; nom: string }) => void;
  handleDeleteMissionCategory: (id: number) => void;
}

const CategoriesMissionTab: React.FC<CategoriesMissionTabProps> = ({
  t,
  loading,
  categoriesMission,
  newCategoryName,
  setNewCategoryName,
  editingMissionCategoryId,
  creatingCategory,
  handleSaveMissionCategory,
  handleCancelEditMissionCategory,
  handleEditMissionCategory,
  handleDeleteMissionCategory,
}) => (
                  <div className="space-y-6">
                    <div>
                      <h2 className="text-lg font-semibold text-white mb-3">
                        {editingMissionCategoryId ? t('categoriesMission.editTitle') : t('categoriesMission.addTitle')}
                      </h2>
                      <p className="text-sm text-gray-400 mb-2">{t('categoriesMission.addDescription')}</p>
                      <div className="flex flex-col sm:flex-row gap-3 flex-wrap">
                        <input
                          type="text"
                          value={newCategoryName}
                          onChange={(e) => setNewCategoryName(e.target.value)}
                          placeholder={t('categoriesMission.placeholder')}
                          className="flex-1 min-w-[200px] px-4 py-2 bg-gray-800/50 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-500"
                        />
                        <div className="flex gap-2">
                          <button
                            type="button"
                            onClick={handleSaveMissionCategory}
                            disabled={creatingCategory}
                            className="px-6 py-2 bg-primary-600 hover:bg-primary-700 text-white rounded-lg font-semibold transition-colors disabled:opacity-60"
                          >
                            {creatingCategory
                              ? t('categoriesMission.saving')
                              : editingMissionCategoryId
                                ? t('categoriesMission.update')
                                : t('categoriesMission.add')}
                          </button>
                          {editingMissionCategoryId && (
                            <button
                              type="button"
                              onClick={handleCancelEditMissionCategory}
                              disabled={creatingCategory}
                              className="px-6 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-lg font-semibold transition-colors disabled:opacity-60"
                            >
                              {t('categoriesMission.cancel')}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="border-t border-gray-700 pt-4">
                      <h2 className="text-lg font-semibold text-white mb-3">{t('categoriesMission.listTitle')}</h2>
                      {loading ? (
                        <p className="text-sm text-gray-500">{t('categoriesMission.loading')}</p>
                      ) : categoriesMission.length === 0 ? (
                        <p className="text-sm text-gray-500">{t('categoriesMission.empty')}</p>
                      ) : (
                        <ul className="divide-y divide-gray-800">
                          {[...categoriesMission].sort((a, b) => a.nom.localeCompare(b.nom, 'fr')).map((c) => (
                            <li
                              key={c.id}
                              className={`py-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 ${editingMissionCategoryId === c.id ? 'rounded-lg bg-primary-900/20 px-3 -mx-1' : ''}`}
                            >
                              <div className="flex flex-wrap justify-between items-center gap-2 text-gray-200 flex-1 min-w-0">
                                <span className="font-medium">{c.nom}</span>
                                <span className="text-xs text-gray-500 shrink-0">ID: {c.id}</span>
                              </div>
                              <div className="flex gap-2 shrink-0">
                                <button
                                  type="button"
                                  onClick={() => handleEditMissionCategory(c)}
                                  disabled={!!creatingCategory}
                                  className="px-2 py-1 text-sm bg-gray-600 hover:bg-gray-500 text-white rounded disabled:opacity-50"
                                >
                                  {t('categoriesMission.modify')}
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handleDeleteMissionCategory(c.id)}
                                  disabled={!!creatingCategory}
                                  className="px-2 py-1 text-sm bg-red-600/80 hover:bg-red-600 text-white rounded disabled:opacity-50"
                                >
                                  {t('categoriesMission.delete')}
                                </button>
                              </div>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
);

export default CategoriesMissionTab;
